import { render } from "./DetentionInfo.vue?vue&type=template&id=badddb36"
import script from "./DetentionInfo.vue?vue&type=script&lang=js"
export * from "./DetentionInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__